import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Container = styled.article`
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  margin: 10rem 0 12rem;
  max-width: 90rem;

  ${mq.smallOnly} {
    flex-direction: column;
    margin: 7rem 0;
    gap: 2rem;
  }

  ${mq.medium} {
    gap: 3rem;
  }

  ${mq.large} {
    margin-left: 3rem;
    margin-right: 3rem;
    gap: 9rem;
  }

  &[data-wide] {
    flex-direction: column;
    gap: 0;
    max-width: 100%;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: calc(100% + 2 * var(--container-spacing));
  margin-left: calc(-1 * var(--container-spacing));
  flex-shrink: 0;
  color: inherit;

  ${mq.medium} {
    width: 40rem;
    margin-left: 0;
  }

  [data-wide] & {
    ${mq.smallOnly} {
      order: 1;
    }

    ${mq.medium} {
      width: 100%;
    }
  }
`

export const Image = styled.img`
  display: block;
  width: 100%;
  aspect-ratio: 400 / 225;
  object-fit: cover;
  color: transparent;
  background: #333;

  [data-wide] & {
    aspect-ratio: 3 / 2;

    ${mq.medium} {
      aspect-ratio: 3 / 1;
    }
  }
`

export const PlayLabel = styled.span`
  display: block;
  position: absolute;
  bottom: 1rem;
  right: 0;
  padding: 0.1rem 0.6rem 0.2rem;
  font-size: 1.4rem;
  background-color: #14130f;

  &::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    border: 0.4em solid transparent;
    border-left-width: 0.6em;
    border-right-width: 0;
    border-left-color: currentColor;
    margin-left: 0.4em;
  }
`

export const ContentWrapper = styled.div`
  position: relative;

  [data-wide] & {
    display: flex;

    ${mq.smallOnly} {
      display: contents;
    }
  }
`

export const Content = styled.div`
  position: relative;

  [data-wide] & {
    padding: 1rem 1.4rem;
    background-color: #14130f;

    ${mq.smallOnly} {
      margin-top: -5rem;
      order: 2;
    }

    ${mq.medium} {
      width: 50%;
      margin: -7rem 3rem 0 auto;
    }

    ${mq.large} {
      margin-right: 8%;
    }
  }
`

export const Title = styled.h3`
  margin: 0;
  font-size: 3.2rem;
  font-weight: 500;

  [data-wide] & {
    margin-top: 2rem;
    font-size: 3.6rem;
  }
`

export const Subtitle = styled.p`
  margin: 0 0 2rem;
  font-size: 2rem;
`

export const Excerpt = styled.p`
  margin: 0;
  font-size: 1.5rem;
  line-height: 1.4;

  [data-wide] & {
    font-size: 1.6rem;
  }
`

export const Footer = styled(Excerpt)`
  margin-top: 0.8em;
`

export const Video = styled.video`
  display: block;
  width: 80vw;
  height: 45vw;
  border: none;

  @media (min-aspect-ratio: 16 / 9) {
    width: 128vh;
    height: 72vh;
  }
`
